import React from 'react';
import { useNavigate } from '@tanstack/react-router';
import { getLocale, localizeHref, locales } from '@/paraglide/runtime.js';

const LanguageSwitcher = () => {
  const navigate = useNavigate();
  const currentLocale = getLocale();

  return (
    <div className="flex items-center gap-1 text-sm font-medium">
      {locales.map((lang, i) => (
        <React.Fragment key={lang}>
          {i > 0 && <span className="text-gray-300">|</span>}
          <button
            onClick={() =>
              navigate({
                href: localizeHref(window.location.pathname, { locale: lang }),
                reloadDocument: true,
              })
            }
            className={`px-1 py-0.5 rounded ${
              currentLocale === lang
                ? 'font-bold text-brand-muted'
                : 'text-gray-500 hover:text-brand-muted cursor-pointer'
            }`}
            aria-current={currentLocale === lang ? 'true' : undefined}
          >
            {lang.toUpperCase()}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
